import * as React from 'react';

import type {ImportStatus} from 'nutshell-graphql-types';

import {Button} from '../button/button';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from '../icon/svg/checkmark-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from '../icon/svg/loading-icon';

import type {ImportType} from './types';

export function getHeaderForStatus(status: ImportStatus): string | null {
    switch (status) {
        case 'IN_PROGRESS':
            return 'Your import is in progress…';
        case 'COMPLETED':
            return 'Your import has finished!';
        default:
            return null;
    }
}

export function getBottomRowForStatusAndType(
    status: ImportStatus,
    type: ImportType,
    count: number | null
): string | null {
    switch (status) {
        case 'IN_PROGRESS':
            return 'Check back in a few minutes';
        case 'COMPLETED':
            if (count === null) {
                return null;
            }

            return `${count} ${type} have been imported`;
        default:
            return null;
    }
}
export function getIconForStatus(status: ImportStatus): React.ReactNode | null {
    switch (status) {
        case 'IN_PROGRESS':
            return <LoadingIcon />;
        case 'COMPLETED':
            return <CheckmarkIcon />;
        default:
            return null;
    }
}

export function buildButtonForStatusAndType(
    status: ImportStatus,
    type: ImportType,
    onRefresh: () => void,
    onViewEntity: () => void,
    completedButtonText?: string | null | undefined
): React.ReactNode | null {
    let text = null;
    let onClick = null;

    switch (status) {
        case 'IN_PROGRESS':
            text = 'Refresh';
            onClick = onRefresh;
            break;
        case 'COMPLETED':
            text = completedButtonText || `View ${type}`;
            onClick = onViewEntity;
            break;
        default:
            return null;
    }

    return (
        <Button onClick={onClick} variant='text-primary'>
            {text}
        </Button>
    );
}
